// `.js` on purpose: scripts/build_seo.mjs imports this file under plain Node.
import { CATALOGUE } from './catalogue.js';

// The crafts, in the order the shelves render. Ids are stable — they are
// baked into badge classes, the admin form and the order form — so a craft
// is renamed here, never re-keyed.
export const CATEGORIES = [
  { id: 'all', name: 'All work', icon: 'Sparkles' },
  { id: 'embroidery', name: 'Embroidery hoops', icon: 'Scissors', badgeClass: 'badge-embroidery', desc: 'Floral, calligraphy and portrait hoop art, stitched by hand' },
  { id: 'painting', name: 'Painted art', icon: 'Palette', badgeClass: 'badge-painting', desc: 'Moon hoops, gold calligraphy on canvas, framed watercolour' },
  { id: 'hampers', name: 'Gift hampers', icon: 'Gift', badgeClass: 'badge-hampers', desc: 'Assembled and hand-finished for weddings, birthdays and festivals' },
  { id: 'designing', name: 'Kids’ wear & garments', icon: 'Crown', badgeClass: 'badge-designing', desc: 'Embroidered frocks and made-to-measure outfits' },
  { id: 'frames', name: 'Frames & keepsakes', icon: 'Frame', badgeClass: 'badge-frames', desc: 'Hand-lettered calligraphy and watercolour, framed' },
];

// The seed catalogue is generated from the studio's own photographs by
// scripts/prepare_works.py. Nothing in it is stock.
export const INITIAL_WORKS = CATALOGUE;

export default INITIAL_WORKS;
